module.exports = __webpack_public_path__ + "be95f935ee67025f70d6dd95ca2f3ba1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/rollerskates-bluegold-s.png
// module id = 2529
// module chunks = 0